import { render, staticRenderFns } from "./UploadSusaDialog.vue?vue&type=template&id=fbc44768"
import script from "./UploadSusaDialog.vue?vue&type=script&lang=js"
export * from "./UploadSusaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports